import { Routes } from '@angular/router';
import { TaasTsHomeComponent } from './features/homepage/home.component';

export const routes: Routes = [
    { path: '', component: TaasTsHomeComponent },
];
